import React, { useState, useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import LoginPage from '../Pages/LoginPage';
import AdministrationPage from '../Pages/AdministrationPage';
import MyCarsPage from '../Pages/MyCarsPage';
import ReservationsPage from '../Pages/ReservationsPage';
import ReportPage from '../Pages/ReportPage';
import PermanentPlaces from '../Pages/PermanentPlaces';
import {
  ADMIN_ROUTE,
  MYCARS_ROUTE,
  RESERVATIONS_ROUTE,
  REPORT_ROUTE,
  DEFAULT_ROUTE,
  LOGOUT_ROUTE,
  BOOKING_DONE_ROUTE,
  LOGIN_ROUTE,
  SHARE_PLACE_ROUTE,
  SHARE_CAR_ROUTE,
  SHARE_PLACE_DONE_ROUTE,
  FREE_PLACES_ROUTE,
  PERMANENT_PLACES_ROUTE,
  BOOKING_FORM
} from './routes';
import Layout from '../utils/layout/Layout';
import Logout from '../Header/NavBar/Logout/Logout';
import BookingPage from '../Pages/BookingPage';
import BookingDonePage from '../Pages/BookingDonePage';
import ProtectedRoute from './ProtectedRoute';
import ShareCarPage from '../Pages/ShareCarPage';
import SharePlacePage from '../Pages/SharePlacePage';
import { getAllUsers } from '../../actions/userActions';
import SharePlaceDonePage from '../Pages/SharePlaceDonePage';
import { fetchCars } from '../../actions/carActions';
import Graph from '../Pages/Graph';
import { setReservationGraphDefault } from '../../actions/reservationGraphActions';
import BookingForm from '../Booking/BookingForm';

function DefaultSwitch() {
  const isLogged = useSelector((state) => state.auth.jwtToken !== null);
  const [isReady, setReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLogged) {
      const p1 = dispatch(getAllUsers());
      const p2 = dispatch(fetchCars());
      const p3 = dispatch(setReservationGraphDefault());
      Promise.all([p1, p2, p3])
        .then(() => {
          setReady(true);
        })
        .catch(() => {
          toast.error('Nepodařilo se spojit se serverem');
        });
    } else {
      setReady(true);
    }
  }, [isLogged]);

  if (!isReady) {
    return <div />;
  }

  return (
    <Layout>
      <Switch>
        <Route path={LOGIN_ROUTE} component={LoginPage} />
        <Route path={LOGOUT_ROUTE} component={Logout} />
        <ProtectedRoute path={DEFAULT_ROUTE} exact component={BookingPage} />
        <ProtectedRoute path={FREE_PLACES_ROUTE} exact component={Graph} />
        <ProtectedRoute path={ADMIN_ROUTE} component={AdministrationPage} />
        <ProtectedRoute path={MYCARS_ROUTE} component={MyCarsPage} />
        <ProtectedRoute
          path={RESERVATIONS_ROUTE}
          component={ReservationsPage}
        />
        <ProtectedRoute path={REPORT_ROUTE} component={ReportPage} />
        <ProtectedRoute path={BOOKING_DONE_ROUTE} component={BookingDonePage} />
        <ProtectedRoute path={SHARE_PLACE_ROUTE} component={SharePlacePage} />
        <ProtectedRoute path={SHARE_CAR_ROUTE} component={ShareCarPage} />
        <ProtectedRoute
          path={SHARE_PLACE_DONE_ROUTE}
          component={SharePlaceDonePage}
        />
        <ProtectedRoute
          path={PERMANENT_PLACES_ROUTE}
          component={PermanentPlaces}
        />
        <ProtectedRoute path={BOOKING_FORM} component={BookingForm} />
      </Switch>
    </Layout>
  );
}

export default DefaultSwitch;
